import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import "@/styles/globals.css";

/**
 * Свежая сборка меняет хэши чанков, а вкладка, открытая ДО неё, при первом
 * переходе на экран просит файл, которого на диске уже нет (экраны едут своими
 * чанками — `App.tsx`). Без этого `import()` отвергается, React размонтирует
 * корень — белый экран. Перезагрузка подтягивает новую сборку с тем же адресом;
 * не чаще раза в 10 секунд, чтобы не зациклиться, если файла нет по другой
 * причине. Хранилище недоступно — не перехватываем: ошибка лучше бесконечного
 * круга.
 */
const ПЕРЕЗАГРУЗКА_КЛЮЧ = "supply:preload-reload";
const ПЕРЕЗАГРУЗКА_НЕ_ЧАЩЕ_МС = 10_000;

function можноПерезагрузить(): boolean {
  try {
    const прошлая = Number(sessionStorage.getItem(ПЕРЕЗАГРУЗКА_КЛЮЧ) ?? 0);
    if (Date.now() - прошлая < ПЕРЕЗАГРУЗКА_НЕ_ЧАЩЕ_МС) return false;
    sessionStorage.setItem(ПЕРЕЗАГРУЗКА_КЛЮЧ, String(Date.now()));
    return true;
  } catch {
    return false;
  }
}

window.addEventListener("vite:preloadError", (event) => {
  if (!можноПерезагрузить()) return;
  event.preventDefault();
  window.location.reload();
});

const container = document.getElementById("root");
if (!container) throw new Error("Нет #root — index.html не тот");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
